<script lang="ts" setup>
  import { computed } from 'vue'

  const model = defineModel<string | undefined | null>()

  import { useDate } from 'vuetify'

  const adapter = useDate()

  function format (date: Date|string|number|null) {
    return adapter.toISO(date)
  }

  const date = computed({
    get () {
      return model.value
    },
    set (newValue) {
      model.value = newValue ? adapter.toISO(newValue) : undefined
    },
  })
</script>

<template>
  <v-date-input
    v-bind="$attrs"
    v-model="date"
    :display-format="format as unknown as string"
    :first-day-of-week="0"
    flat
  />
</template>
